import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { pulseAnimation } from '../../utils/animations';

interface LiveIndicatorProps {
  isConnected: boolean;
  showLabel?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const LiveIndicator: React.FC<LiveIndicatorProps> = ({ 
  isConnected, 
  showLabel = true,
  size = 'medium' 
}) => {
  const sizeMap = {
    small: 6,
    medium: 8,
    large: 10,
  };

  const dotSize = sizeMap[size];

  return (
    <Tooltip 
      title={isConnected ? 'Connected to server' : 'No connection to server'}
      arrow
    >
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          cursor: 'pointer',
        }}
      >
        <Box
          sx={{
            width: dotSize,
            height: dotSize,
            borderRadius: '50%',
            bgcolor: isConnected ? '#10B981' : '#EF4444',
            animation: isConnected ? `${pulseAnimation} 2s infinite` : 'none',
            boxShadow: isConnected 
              ? '0 0 12px rgba(16, 185, 129, 0.6)' 
              : '0 0 8px rgba(239, 68, 68, 0.4)',
            transition: 'all 0.3s ease',
          }}
        />
        {showLabel && (
          <Typography 
            variant="caption" 
            sx={{ 
              color: isConnected ? 'success.main' : 'error.main',
              fontWeight: 600,
              fontSize: size === 'small' ? '0.7rem' : '0.75rem',
            }}
          >
            {isConnected ? 'Live' : 'Offline'}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default LiveIndicator;
